import { Spin, Modal } from "antd";
import React, { useState } from "react";
import ClassForm from "./ClassForm";
import { updateClass } from "../../../../services/trialClassService";
import moment from "moment";

function ClassEdit(props) {
  const trialClass = props.trialClass;

  const initialValues = {
    location: trialClass.location,
    timezone: trialClass.timezone,
    startDate: moment(trialClass.startDate).local(),
    endDate: moment(trialClass.endDate).local(),
    maxVacancy: trialClass.maxVacancy,
    classCode: trialClass.classCode,
    classLink: trialClass.classLink,
  };

  const [status, setStatus] = useState({
    type: "IDLE",
    message: "In idle mode",
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values,
    };

    await updateClass(payload, trialClass.classCode)
      .then((response) => {
        console.log("Successfully Updated! ", response);
        setStatus({ type: "SUCCESS", message: "Data updated successfully!" });
      })
      .catch((error) => {
        alert("Posting data from the backend failed!");
        if (error?.response?.data?.message)
          setStatus({ type: "ERROR", message: error.response.data.message });
        else setStatus({ type: "ERROR", message: "Something went wrong!" });
      });
  };

  return (
    <Modal
      title={`Edit Unit ${trialClass.classCode}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === "LOADING" ? (
        <Spin size="large" />
      ) : (
        <ClassForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
        />
      )}
    </Modal>
  );
}

export default ClassEdit;
